import { useEffect } from 'react';

import { TranslationService } from '@/utils/services/TranslationService';

import useSocialProfiles from '@/hooks/swr/useSocialProfiles';
import useSPGroups from '@/utils/hooks/swr/group/useSPGroups';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import { setCollaborationHasVisitedLocalStorage } from '@/utils/localStorage/scheduler/collaborationLocalStorage';

// Hooks
import { SCHEDULER_COLLABORATION_SETTINGS } from '@/lib/routes/privateRoutes';

// Components
import H3 from '@/components/base/Headings/H3';
import Loader from '@/components/base/Loader';
import CollaborationWrapper from '@/components/pages/scheduler/collaboration/CollaborationWrapper';
import Form from '@/components/pages/scheduler/collaboration/settings/Form';
import { Trans } from '@/components/tools/translation';

const SharingSettings = () => {
    const { t } = useTranslation('scheduler');

    const { isLoading: isLoadingGroups } = useSPGroups();
    const { isLoading: isLoadingSPs } = useSocialProfiles({
        revalidateOnMount: false,
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    useEffect(() => {
        setCollaborationHasVisitedLocalStorage(true);
    }, []);

    return (
        <CollaborationWrapper>
            <div className="flex flex-1 flex-col rounded-md bg-white dark:bg-icoDarkMode-anthracite lg:flex-row">
                {/* Form part */}
                <div className="w-full flex-1 px-8 py-10 lg:px-20">
                    <div className="mb-4">
                        <H3>{t('collaboration.settings.link_settings')}</H3>
                        <p className="mt-1 font-GMedium text-sm text-icoGray-500">
                            <Trans
                                i18nKey="scheduler:collaboration.settings.link_settings_notice"
                                components={{
                                    tag0: <span key="italic-notice" className="block italic" />
                                }}
                            />
                        </p>
                    </div>
                    {isLoadingGroups || isLoadingSPs ? (
                        <div className="flex w-full items-center justify-center p-40">
                            <Loader className="h-8 w-8 text-icoBlue" />
                        </div>
                    ) : (
                        <Form />
                    )}
                </div>
            </div>
        </CollaborationWrapper>
    );
};

export const getStaticProps = TranslationService.getTranslationMessagesFromRoute(
    SCHEDULER_COLLABORATION_SETTINGS
);

export default SharingSettings;
